import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoring/milestones/today/styles.scss';export default {
  "today": "_today_wmbqs_1",
  "name": "_name_wmbqs_7",
  "icon": "_icon_wmbqs_12"
};